import { jsx as _jsx } from "react/jsx-runtime";
import { isSupportedOS as isDesktopOS } from "@tv4/avod-web-player-device-capabilities";
import styled, { css } from "styled-components";
import TracksSvg from "../../../icons/tracks.svg";
import { useTracksMenuOpen } from "../../../providers/LayoutProvider";
import { useTranslations } from "../../../providers/TranslationsProvider";
import { PlayerControlLabelButton } from "../../PlayerControlLabelButton";
const Button = styled(PlayerControlLabelButton) `
  padding: ${({ $usePadding }) => ($usePadding ? "0.5em" : "0em")};
  ${({ $isOpen, $usePadding }) => $isOpen &&
    $usePadding &&
    css `
      background: rgba(255, 255, 255, 0.2);
      border-radius: 8px;
    `}

  opacity: ${({ $hasTracksToChooseFrom }) => $hasTracksToChooseFrom ? 1 : 0.7};
`;
export const TracksButton = ({ hasTracksToChooseFrom, onClick, label, buttonRef, }) => {
    const { tracksMenuOpen } = useTracksMenuOpen();
    const translations = useTranslations();
    return (_jsx(Button, { disabled: false, "aria-label": translations(tracksMenuOpen
            ? "player__a11y__voice_over_close_language_menu"
            : "player__a11y__voice_over_open_language_menu"), "aria-haspopup": "true", 
        // aria-expanded={tracksMenuOpen}
        buttonRef: buttonRef, "$isOpen": tracksMenuOpen, "$usePadding": isDesktopOS(), "$hasTracksToChooseFrom": hasTracksToChooseFrom, Icon: _jsx(TracksSvg, {}), label: label, onClick: onClick, hoverText: translations("player__a11y__hover_label_language_menu_button") }));
};
